export default __webpack_public_path__ + "static/media/ic-fr.7477c7c0.svg";